import {css} from '@emotion/react'
import {useAiContext} from '@/biz/ai'

const cssScene = css({
    color: 'rgba(0, 0, 0, 0.45)',
    padding: 4,

    '&:empty': {
        padding: 0,
    }
})

export const Scene = (props) => {
    const ai = useAiContext()
    const name = ai.template?.usageScenario
    const {prj, prjNo} = ai.project ?? {}

    return (
        <div
            css={cssScene}
            {...props}
        >
            {name} [{prjNo}]{prj}
        </div>
    )
}
